import React from 'react'
import PropTypes from 'prop-types'
import { TransactionType, WithdrawalStatus } from '../../utils/const'
import { translateChallengeType, translateLeaderboardWinnerType } from '../../utils/translate'

const TransactionsTable = ({ transactions }) => (

    <table className="table lobby-table table-hover table-striped match-history">
        <thead>
            <tr>
                <th>Type</th>
                <th>Date played</th>
                <th>Amount</th>
            </tr>
        </thead>
        <tbody>
            {typeof transactions === 'undefined' ? 'Loading...' : (transactions.map((transaction, index) => (
                <tr key={transaction.id}>
                    <td>
                        {descriptionText(transaction.type, transaction.challengeType, transaction.challengeId, transaction.withdrawalStatus, transaction.leaderboardWinnerType)}
                    </td>
                    <td>
                        {dateFormat(transaction.created)}
                    </td>
                    <td className="points text-left">
                        {transaction.amount} <small>{transaction.currencyCode || 'USD'}</small>
                    </td>
                </tr>
            )))}
        </tbody>
    </table>
)

function dateFormat(date) {
    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}

function descriptionText(type, challengeType, challengeId, withdrawalStatus, leaderboardWinnerType) {
    if (type === TransactionType.DEPOSIT) {
        return "Deposit";
    }
    else if (type === TransactionType.WITHDRAWAL) {
        return "Withdrawal" + withdrawalStatusText(withdrawalStatus);
    }
    else if (type === TransactionType.PAYED_CHALLENGE_FEE) {
        return "Challenge entry fee #" + challengeId + " (" + translateChallengeType(challengeType) + ")";
    }
    else if (type === TransactionType.CHALLENGE_PAYOUT) {
        return "Challenge payout #" + challengeId + " (" + translateChallengeType(challengeType) + ")";
    }
    else if (type === TransactionType.REFUNDED_CHALLENGE_FEE) {
        return "Challenge refund #" + challengeId + " (" + translateChallengeType(challengeType) + ")";
    }
    else if (type === TransactionType.PROMOTION) {
        return "Promotion";
    }
    else if (type === TransactionType.LEADERBOARD_PAYOUT) {
        return translateLeaderboardWinnerType(leaderboardWinnerType) + " leaderboard winner";
    }
    else if (type === TransactionType.DISCOUNT_CODE) {
        return "Coupon redeemed";
    }
    else {
        return type;
    }
}

function withdrawalStatusText(withdrawalStatus) {
    if (withdrawalStatus === WithdrawalStatus.REQUESTED) {
        return " (Pending payout)";
    }
    else if (withdrawalStatus === WithdrawalStatus.COMPLETE) {
        return " (Complete)";
    }
    else if (withdrawalStatus === WithdrawalStatus.DENIED) {
        return " (Denied)";
    }
    else if (withdrawalStatus === WithdrawalStatus.FAILED) {
        return " (Failed)";
    }
    else {
        return "";
    }
}

export default TransactionsTable